export default __webpack_public_path__ + "static/media/Ao.1b9a1978.jpg";